import { render, staticRenderFns } from "./SupplierDeleteConfirmationDialog.vue?vue&type=template&id=5bf2ff4c&lang=pug&"
import script from "./SupplierDeleteConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./SupplierDeleteConfirmationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports